import React, {useState, useEffect} from "react";
import Logo from './logo';
import { Link } from "react-router-dom";
import AuthorizedMenu from './AuthorizedMenu'
import MobileNav from './mobile-nav';
import { useNavigate } from "react-router-dom";

import { Drawer } from "flowbite";
import axios from 'axios';  

import {APP_URL} from 'components/config/Common';
import {useAuth} from '../contexts/provider/AuthProvider'
import { BsFillTelephoneFill } from "react-icons/bs";
import {admin_phone,EXPERT_LABEL , API_ENDPOINT , BACKEND_URL} from '../components/config/Common'
import {Links} from '../routes/PathLink'
import ModalView from '../_utils/ModalView'
import Search from 'components/ui/search/search.tsx'
import { ChevronRightIcon } from '@heroicons/react/solid'
import { AiFillTwitterCircle, AiFillInstagram, AiFillFacebook, AiFillLinkedin } from 'react-icons/ai';

const Header = (props) => {
    const {hidesearch ,hidebanner , hidelogo } = props;
    const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
    const [user_type,setUser_type] = useState(localStorage.getItem('user_type'));

    const { logout, isUser } = useAuth();
    const [openLogin, setOpenLogin] = useState(false)
    const [isLogin, setIsLogin] = useState(false)
    const [drawerVisible, setDrawerVisible] = useState(false)
    const [openLoginNav, setOpenLoginNav] = useState(false)

    const [callNowModal, setCallNowModal] = useState(false)
    const [authModelView, setAuthModelView] = useState('LoginView')
    const [totalamount,setTotalamount] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        //console.log('props===========',props)
        if(access_token){
            setIsLogin(true)
           
            
        }
    }, [access_token])

    const openLoginModal = (loginView) => {        
        setOpenLogin(!openLogin)
        setAuthModelView(loginView)
        setOpenLoginNav(false)
    }
   

      
    const logoutUser = () => {
        
        let user_name = localStorage.getItem("user_name")
        let user_type = localStorage.getItem("user_type")

        console.log("usertype",user_type);
       

        localStorage.removeItem("access_token")
        localStorage.removeItem("user_type")
        localStorage.removeItem("user_id")
        localStorage.removeItem("user_name")

        //sessionStorage.clear()
       
        logout()
        setIsLogin(false)
        navigate(
            Links.LOGOUT,
            {
               state: { user_name: user_name },
               replace: true 
            },
            
        );
    }
    const cart_count = (count) => {
        //setCartCount(count)
    }



    const openDrawer = () => {
        const options = {
            placement: 'right',
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: '',
            backdropClasses: 'cart-drawer bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-60',
            onHide: () => {
                //console.log('drawer is hidden');
                setDrawerVisible(false)
            },
            onShow: () => {
                //console.log('drawer is shown');
                setDrawerVisible(true)
            },
            onToggle: () => {
                //console.log('drawer has been toggled');
            }
          };
        const $targetEl = document.getElementById('drawer-right-example');
        const drawer: DrawerInterface = new Drawer($targetEl, options);
        drawer.show();
    }
        
    
    
    const closeDrawer = () => {
        //console.log('close drawer')
        const options1 = {
            placement: 'right',
            backdrop: false,
            bodyScrolling: true,
            edge: false,
            edgeOffset: '',
            backdropClasses: 'bg-gray-900 bg-opacity-0 dark:bg-opacity-0 fixed',
          };
        const $targetEl = document.getElementById('drawer-right-example');
        const drawer: DrawerInterface = new Drawer($targetEl, options1);
        drawer.hide();
        let cartDrawer = document.querySelector(".cart-drawer");
        let body = document.querySelector("body");
        cartDrawer.remove();
        body.classList.remove("overflow-hidden");
    }
        

    
    const closeLoginNav = () => {
        setOpenLoginNav(false)
        setCallNowModal(false)
    }

    

    const openLoginNavModal = () => {
        //setOpenLoginNav(true)
    }
    const openCallNowModal = () => {
        setCallNowModal(true)
    }

    
    const openLoginPage = () =>{
        /*navigate(Links.USER_LOGIN, {
               replace: true 
            },);
            */
       navigate(Links.USER_LOGIN);
    }
   const openRegistrationPage = () =>{
        /*navigate(Links.USER_LOGIN, {
               replace: true 
            },);
            */
       navigate(Links.USER_SIGNUP);
    }
  
    return (
        <>
        <header className={'site-header-with-search hidden md:block z-[60] '}>
            <div
                className={'flex w-full transform-gpu items-center justify-between border-b border-border-200 bg-light px-4 py-2 shadow-sm transition-transform duration-300 lg:px-8 dark:bg-gray-800 dark:border-gray-600'}
             >
                <div className="flex w-full items-center lg:w-auto">
                   {hidelogo ? null :
                    (<Logo className={'ltr:ml-0 rtl:mr-0 text-accent'} />)
                    }
                </div>
                <ul className="hidden shrink-0 items-center space-x-7 rtl:space-x-reverse lg:flex 2xl:space-x-10">
                    <li>
                       {hidesearch ? null : (
                    <li>
                        <Search
                        placeholder="Search Company"
                        variant={'minimal'}
                        className="pl-10"  />
                    </li>
                    )}
                    </li>
                     <li>
                        <Link
                            to={`${APP_URL}`}
                            className="flex items-center font-medium  no-underline uppercase antialiased transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >Home</Link>
                    </li>
                    {/*<li>
                        <a
                            href={'#'}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >News</a>
                    </li>*/}
                     <li>
                        <Link
                            to={`${APP_URL}${Links.SCREENS}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >Screens</Link>
                    </li>
                     <li>
                        <Link
                            to={`${APP_URL}${Links.CONCALLS}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >CONCALL</Link>
                    </li> 
                     <li>
                        <Link
                            to={`${APP_URL}${Links.IPO}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >IPO</Link>
                    </li> 
                     {/*<li>
                        <Link
                            to={`${APP_URL}${Links.IPO}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >IPO</Link>
                    </li> 
                    <li>
                        <Link
                            to={`${APP_URL}${Links.SECTORS}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >Sectors</Link>
                    </li>
                    <li>
                        <Link
                            to={`${APP_URL}${Links.INDICES}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >Indices</Link>
                    </li>*/}
                     <li>
                        <Link
                            to={`${APP_URL}/news`}
                            target="_blank"
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >News</Link>
                    </li>
                     <li>
                        <Link
                            to={`${APP_URL}/news/news-videos/`}
                            target="_blank"
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >News Videos </Link>
                    </li>
                     {hidesearch ? <>
                   {/* <li>
                        <Link
                            to={`${APP_URL}${Links.SMEMARKET}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >SME</Link>
                    </li>
                   
                    <li>
                        <Link
                            to={`${APP_URL}${Links.SUPERINVESTORS}`}
                            className="flex items-center font-medium  no-underline antialiased uppercase transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                        >Indian Top Investors</Link>
                    </li>*/}
                                       
                    </>
                     :
                    null
                    }
                    <div className="flex items-center space-x-4 rtl:space-x-reverse">
                        {/* <a href="#" target="_blank" rel="noreferrer" className="inline-flex h-9 shrink-0 items-center justify-center rounded border border-transparent bg-accent px-3 py-0 text-sm font-semibold leading-none text-light outline-none transition duration-300 ease-in-out hover:bg-accent-hover focus:shadow focus:outline-none focus:ring-1 focus:ring-accent-700">Become a Seller</a> */}
                        
                        <li>
                        {
                        !isUser ?
                           <div className="flex gap-2"> 
                            <button data-variant="normal" className="inline-flex items-center justify-center shrink-0 font-semibold leading-none rounded outline-none transition duration-300 ease-in-out focus:outline-none focus:shadow focus:ring-1 focus:ring-accent-700 bg-accent text-light border border-transparent hover:bg-accent-hover px-3 py-0 h-9 text-sm font-semibold uppercase" onClick={openLoginPage}>Login</button>
                            <button data-variant="normal" className="inline-flex items-center justify-center shrink-0 font-semibold leading-none rounded outline-none transition duration-300 ease-in-out focus:outline-none focus:shadow focus:ring-1 focus:ring-accent-700 bg-accent text-light border border-transparent hover:bg-accent-hover px-3 py-0 h-9 text-sm font-semibold uppercase" onClick={openRegistrationPage}>Get Free Account</button>
                            </div>
                        :
                        <AuthorizedMenu logout={logoutUser}  />
                        }
                        </li>
                    </div>
                      {/*
                      !isUser ?
                      <div className="flex ">
                        <a href="https://www.facebook.com/healthlogist" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#1877f2]"><AiFillFacebook /></a>
                        <a href="https://x.com/healthlogist1" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#1da1f2]"><AiFillTwitterCircle /></a>
                        <a href="https://www.instagram.com/healthlogist1" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#c13584]"><AiFillInstagram /></a>
                        <a href="https://www.linkedin.com/company/healthlogist" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#c13584]"><AiFillLinkedin /></a>
                         <a href="https://play.google.com/store/apps/details?id=com.sisnolabs.healthlogist" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-white hover:text-[#0A66C2]">
                          <img alt="Download App from play store" 
                           loading="lazy" 
                           decoding="async" 
                           data-nimg="1" 
                           class="w-8 h-8 object-contain" src={`${BACKEND_URL}/img/playstore_icon.png`} 
                        /></a>
                    </div>
                    :
                    null
                    */}
                </ul>
            </div>
        </header>
        <MobileNav openLogin={openLoginNavModal} drawerVisible={openDrawer} hidelogo={hidelogo} />
        {/*hidesearch ?
        (null)
        :(<Search
          variant={'minimal'}
          className=""  />)
        */}
        <ModalView open={openLoginNav} onClose={closeLoginNav}>
            <div className="flex h-full min-h-screen w-screen flex-col justify-center bg-light py-6 px-5 sm:p-8 md:h-auto md:min-h-0 md:max-w-[500px] md:rounded-xl">
                <div className="flex items-center justify-around flex-wrap">
                    <div className="p-2 mt-8 lg:p-0">
                        <button data-variant="normal" className="inline-flex items-center justify-center shrink-0 rounded outline-none transition duration-300 ease-in-out focus:outline-none focus:shadow focus:ring-1 focus:ring-accent-700 bg-accent text-light border border-transparent hover:bg-accent-hover px-5 py-5 text-xl " onClick={() => navigate(Links.PATIENT_LOGIN)}>Patient Login</button>
                    </div>
                     <div className="p-2 mt-8 lg:p-0">
                        <button data-variant="normal" className="inline-flex items-center justify-center shrink-0 rounded outline-none transition duration-300 ease-in-out focus:outline-none focus:shadow focus:ring-1 focus:ring-accent-700 bg-accent text-light border border-transparent hover:bg-accent-hover px-5 py-5 text-xl " onClick={() => navigate(Links.DOCTOR_SIGNUP)}>Doctor Login</button>
                    </div>
                </div>
            </div>
        </ModalView>
        </>
    )
}


export default Header;
